import React, { memo } from 'react';
import { Typography } from 'fmc-digital-common';
const DocUploadHeader = ({
  title
}) => {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: 'subtitle1',
    color: 'darkGray.900',
    marginBottom: 2
  }, title);
};
export default /*#__PURE__*/memo(DocUploadHeader);
//# sourceMappingURL=index.js.map